import { Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ValidationMessagesService } from 'src/app/core/services/index.service';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss']
})
export class ErrorMessageComponent {

  @Input() formName: FormGroup = new FormGroup({});
  @Input() field: FormControl = new FormControl("");
  @Input() fieldName: string = "";
  @Input() type: string = "";
  lang: any;
  getFieldName: any;
  constructor(
    public formBuilder: FormBuilder,
    public validationMessages: ValidationMessagesService) {
  }

  ngOnChanges() {
    this.getFieldName = this.validationMessages.validation_messages[this.fieldName];
  }

}
